import { inject } from '@angular/core';
import { AppDataService } from 'app/services';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MenuPermissionActionEnum } from 'app/models';

export const canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const appDataService = inject(AppDataService);
	const router = inject(Router);
	const requiredPermission = route.data['permission'];
	if (appDataService.hasPermission(requiredPermission, MenuPermissionActionEnum.Read)) {
		return true;
	} else {
		return router.parseUrl('/unauthorized');
	}
};
